<template>
  <form @submit="onSubmit">
    <slot :push="push" :remove="remove" :fields="fieldsList" :errors="errors"></slot>
  </form>
</template>

<script setup>
import {  computed, toRef, provide } from "vue";
import { useForm, useFieldArray } from "vee-validate";
import yup from "@/utils/yup";

const emit = defineEmits(["submit"]);

const props = defineProps({
  name: {
    type: String,
    default: "",
  },
  fields: {
    type: Object,
    default: () => ({}),
  },
  validationSchema: {
    type: Object,
    default: () => ({}),
  },
});
const { errors, setErrors, setFieldValue, handleSubmit, values, resetForm } = useForm({
  validationSchema: computed(() => props.validationSchema),
  initialValues: computed(() => {
    return props.fields;
  }),
});

const { remove, push, fields: fieldsList } = useFieldArray(toRef(props, "name"));

const onSubmit = handleSubmit((values, actions) => {
  emit("submit", { values: values, ...actions, reset: resetForm });
});

provide('setFormFieldValue', setFieldValue)

</script>

<style></style>
